import { render, staticRenderFns } from "./communication.vue?vue&type=template&id=43c373c6&scoped=true"
import script from "./communication.vue?vue&type=script&lang=js"
export * from "./communication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c373c6",
  null
  
)

export default component.exports